var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"setup-container"},[_c('h3',[_vm._v("Let's setup your account")]),_c('SetupProgress',{attrs:{"user":_vm.user,"progress":_vm.progress,"step":_vm.step}})],1),_c('SetupAccountForm',{attrs:{"user":_vm.user,"loading":_vm.loading,"code":_vm.code},on:{"setProgress":_vm.setProgress,"setStep":_vm.setStep}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }